import { ACTION_TYPE } from '../actions/actionTypes';

const fundFactsheetReducer = (state = [], action) => {
  switch (action.type) {
    case ACTION_TYPE.GET_PRODUCTS_OVERVIEW:
      return { ...state, funds: action.payload };
    case ACTION_TYPE.SAVE_FUND_FACTSHEET:
      return { ...state, fundDetail: action.payload };
    default:
      return state;
  }
};

export default fundFactsheetReducer;
